{
  "storeCredit": "store credit",
  "price": {
    "samePrice": "Same price",
    "increaseWaived": "+{amount} waived",
    "increaseToPay": "+{amount} to pay",
    "paymentRequiredAtCheckout": "Payment required at checkout",
    "refundLabel": "{amount} refund",
    "refundDescription": "Refunded to original payment",
    "storeCreditLabel": "{amount} {storeCredit}",
    "storeCreditDescription": "Issued as {storeCredit}",
    "noRefundLabel": "No refund for difference"
  },
  "variantSelection": {
    "lookingForSomethingElse": "Looking for something else?",
    "browseAllProducts": "Browse all products"
  },
  "variantOption": {
    "outOfStock": "Out of stock"
  },
  "optionButton": {
    "notAvailable": "Not available"
  },
  "miniPdp": {
    "zoom": "Click to zoom",
    "zoomedImage": "Zoomed image",
    "selectVariant": "Select this variant",
    "selectOptions": "Select options to continue"
  },
  "productBrowser": {
    "searchPlaceholder": "Search products...",
    "allCategories": "All categories",
    "noProducts": "No products found",
    "loadMore": "Load more"
  },
  "productCard": {
    "variants": {
      "one": "{count} variant",
      "other": "{count} variants"
    }
  },
  "redirectConfirmation": {
    "greatChoice": "Great choice!",
    "title": "Exchange item selected."
  },
  "payment": {
    "exchangePriceDifference": "Exchange price difference",
    "instantResolutionGuarantee": "Instant resolution guarantee",
    "totalAuthorization": "Total authorization",
    "authorizationAmount": "Authorization amount",
    "totalInfo": "Your card will be authorized for the total amount. The exchange charge will be captured when your order ships. The instant resolution authorization will be released when we receive your returned items.",
    "instantOnlyInfo": "A temporary authorization will be placed on your card so you can receive your resolution immediately. This authorization will be released once we receive your returned items.",
    "priceDifferenceOnlyInfo": "Your card will be authorized for this amount. The charge will only be captured when your exchange order ships.",
    "loadingForm": "Loading payment form...",
    "formNotInitialized": "Payment form not initialized",
    "informationUnavailable": "Payment information not available",
    "setupFailed": "Payment setup failed",
    "loadFailed": "Failed to load payment form. Please try again."
  }
}
